import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { API } from "@/lib/api";

const resolveImg = (src) => (src?.startsWith("http") ? src : `${API}/files/${src}`);

export const ResourceCard = ({ resource }) => {
  const { slug, title, excerpt, cover_image } = resource;
  return (
    <Link
      to={`/resources/${slug}`}
      data-testid={`resource-card-${slug}`}
      className="group flex flex-col border border-border rounded-sm overflow-hidden bg-card hover:border-primary transition-colors"
    >
      <div className="aspect-[4/3] bg-secondary overflow-hidden">
        {cover_image ? (
          <img src={resolveImg(cover_image)} alt={title}
               className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs tracking-[0.2em] uppercase">
            Alteza · Resource
          </div>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-serif text-xl leading-snug">{title}</h3>
        {excerpt && <p className="mt-3 text-sm text-muted-foreground leading-relaxed flex-1">{excerpt}</p>}
        <span className="mt-5 inline-flex items-center gap-2 text-sm text-primary font-medium">
          Read the Guide <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
};
